import { ProductBatch } from "@/pages/caster/models/DeliveryTicket";
import { CatalogMoldSize } from "@/pages/caster/models/catalogs/CatalogMoldSize";

export const calculateBatchWeight = (
	batch: ProductBatch,
	moldSizeId: number | null,
	moldSizes: CatalogMoldSize[] | null,
): ProductBatch => {
	const moldSizeWeight =
		moldSizes?.find((ms) => ms.MoldSizeId === moldSizeId)?.LbsPerFoot || 0;
	const lengthInFeet = (Number(batch.Length) || 0) / 12;
	const weightPerPiece = lengthInFeet * moldSizeWeight;
	const totalWeight = weightPerPiece * (Number(batch.Pieces) || 0);

	return {
		...batch,
		Weight: Number(totalWeight.toFixed(2)),
		WeightPerPiece: Number(weightPerPiece.toFixed(2)),
	};
};

export const updateBatchesWithWeight = (
	prevBatches: ProductBatch[],
	moldSizeId: number | null,
	moldSizes: CatalogMoldSize[] | null,
): ProductBatch[] => {
	return prevBatches.map((batch) =>
		calculateBatchWeight(batch, moldSizeId, moldSizes),
	);
};
